<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://rotaneta.com" target="_blank">Rotaneta Teknoloji ve Turizm A.Ş. - </b-link>
      <span class="d-none d-sm-inline-block"> {{ $t("common.allRightsReserved") }}</span>
    </span>
  </p>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
